import { Button } from "baseui/button"
import { VscEdit } from "react-icons/vsc"
import { IEnergyRate } from "./types";
import { useState } from "react";
import EditEnergyRateModal from "./EditEnergyRateModal/EditEnergyRateModal";

const EditEnergyRateButton = (props: IEnergyRate) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (e) => { e.stopPropagation(); e.preventDefault(); setIsOpen(true); }

    return (
        <>
            <Button onClick={handleClick} shape="round" kind="tertiary"><VscEdit></VscEdit></Button>
            {isOpen &&
                <EditEnergyRateModal onClose={() => setIsOpen(false)} isOpen={isOpen} {...props}></EditEnergyRateModal>
            }
        </>
    )
}

export default EditEnergyRateButton;